import { render, staticRenderFns } from "./ReviewDashboardInpatient.vue?vue&type=template&id=2fbd3545&scoped=true&"
import script from "./ReviewDashboardInpatient.vue?vue&type=script&lang=js&"
export * from "./ReviewDashboardInpatient.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDashboardInpatient.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReviewDashboardInpatient.vue?vue&type=style&index=1&id=2fbd3545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd3545",
  null
  
)

export default component.exports